import { Component, OnInit, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { VariablesGlobalesService } from '../../services/variables-globales.service';
import { EncriptarService } from '../../services/encriptar.service';
import { setOptions } from '@mobiscroll/angular';
import { localeEn, localeEs, localeCa, localeDe, localeFr, localeIt, localePtPT, localeUa } from '@mobiscroll/angular';
import { TitleCasePipe } from '@angular/common';
import { ModalController, IonButton, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonItem, IonModal, IonRadio, IonRadioGroup, IonRow, IonTitle, IonToolbar } from '@ionic/angular/standalone';

setOptions({
  theme: 'windows',
});

@Component({
    selector: 'app-selector-idioma',
    templateUrl: './selector-idioma.component.html',
    styleUrls: ['./selector-idioma.component.scss'],
    standalone: true,
    imports : [IonHeader,IonItem, IonModal,IonToolbar, IonTitle,IonRadio, IonRadioGroup, IonContent,IonFooter, IonGrid, IonRow, IonCol,IonButton,
    TitleCasePipe  , TranslateModule]
})
export class SelectorIdiomaComponent implements OnInit {
  private translate = inject(TranslateService);
  variablesGlobales = inject(VariablesGlobalesService);
  private servicioEncriptar = inject(EncriptarService);
  private modalCtrl = inject(ModalController);

  idiomaSeleccionado: any = null
  tmpIdioma:string = '';
  idiomas = [
    {
      text: 'Català',
      value: 'ca-ES',
      abreviatura: 'Ca',
      img: './assets/imagenes/banderas/ca-ES.svg'
    },
    {
      text: 'Deutsch',
      value: 'de-DE',
      abreviatura: 'De',
      img: './assets/imagenes/banderas/de-DE.svg'
    },
    {
      text: 'English',
      value: 'en-US',
      abreviatura: 'En',
      img: './assets/imagenes/banderas/en-US.svg'
    },
    {
      text: 'Español',
      value: 'es-ES',
      abreviatura: 'Es',
      img: './assets/imagenes/banderas/es-ES.svg'
    },
    {
      text: 'Euskera',
      value: 'eu-ES',
      abreviatura: 'Eu',
      img: './assets/imagenes/banderas/eu-ES.svg'
    },
    {
      text: 'Français',
      value: 'fr-FR',
      abreviatura: 'Fr',
      img: './assets/imagenes/banderas/fr-FR.svg'
    },
    {
      text: 'Galego',
      value: 'gl-ES',
      abreviatura: 'Gl',
      img: './assets/imagenes/banderas/gl-ES.svg'
    },
    {
      text: 'Italiano',
      value: 'it-IT',
      abreviatura: 'It',
      img: './assets/imagenes/banderas/it-IT.svg'
    },
    {
      text: 'Português',
      value: 'pt-PT',
      abreviatura: 'Pt',
      img: './assets/imagenes/banderas/pt-PT.svg'
    },
    {
      text: 'український',
      value: 'uk-UA',
      abreviatura: 'Ua',
      img: './assets/imagenes/banderas/uk-UA.svg'
    }
  ];

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    this.translate.use(this.variablesGlobales.idiomaSeleccionado);
    this.idiomaSeleccionado = this.idiomas.find(idioma => idioma.value == this.variablesGlobales.idiomaSeleccionado)
    if(!this.idiomaSeleccionado){
      this.idiomaSeleccionado = this.idiomas.find(idioma => idioma.value == 'es-ES')
    }
    console.log('idiomaSeleccionado', this.idiomaSeleccionado);

  }

  ngOnInit() {

  }

  async idiomaCambiado(event){
    this.tmpIdioma = event.detail.value
    this.translate.use(this.tmpIdioma)
    this.variablesGlobales.idiomaSeleccionado = this.tmpIdioma
    this.idiomaSeleccionado = this.idiomas.find(idioma => idioma.value == this.tmpIdioma)
    if(this.tmpIdioma == 'es-ES' || this.tmpIdioma == 'eu-ES' || this.tmpIdioma == 'gl-ES'){
      this.variablesGlobales.localeMbs = localeEs
    }else if(this.tmpIdioma=='ca-ES'){
      this.variablesGlobales.localeMbs = localeCa
    }else if(this.tmpIdioma == 'de-DE'){
      this.variablesGlobales.localeMbs = localeDe
    }else if(this.tmpIdioma == "en-US"){
      this.variablesGlobales.localeMbs = localeEn
    }else if(this.tmpIdioma == 'fr-FR'){
      this.variablesGlobales.localeMbs = localeFr
    }else if(this.tmpIdioma == 'it-IT'){
      this.variablesGlobales.localeMbs = localeIt
    }else if(this.tmpIdioma == 'pt-PT'){
      this.variablesGlobales.localeMbs = localePtPT
    }else if(this.tmpIdioma == 'uk-UA'){
      this.variablesGlobales.localeMbs = localeUa
    }
    await this.servicioEncriptar.guardarEnStorage('idiomaSeleccionado', JSON.stringify(this.variablesGlobales.idiomaSeleccionado));
  }

  async cambiarIdioma() {
    console.log('tmpIdioma: ',this.tmpIdioma, ' idiomaSeleccionado: ',this.idiomaSeleccionado);
    if(this.tmpIdioma!='' && (this.tmpIdioma!= this.idiomaSeleccionado.value)){
      this.translate.use(this.tmpIdioma)
      this.variablesGlobales.idiomaSeleccionado = this.tmpIdioma
      this.idiomaSeleccionado = this.idiomas.find(idioma => idioma.value == this.tmpIdioma)
      if(this.tmpIdioma == 'es-ES' || this.tmpIdioma == 'eu-ES' || this.tmpIdioma == 'gl-ES'){
        this.variablesGlobales.localeMbs = localeEs
      }else if(this.tmpIdioma=='ca-ES'){
        this.variablesGlobales.localeMbs = localeCa
      }else if(this.tmpIdioma == 'de-DE'){
        this.variablesGlobales.localeMbs = localeDe
      }else if(this.tmpIdioma == "en-US"){
        this.variablesGlobales.localeMbs = localeEn
      }else if(this.tmpIdioma == 'fr-FR'){
        this.variablesGlobales.localeMbs = localeFr
      }else if(this.tmpIdioma == 'it-IT'){
        this.variablesGlobales.localeMbs = localeIt
      }else if(this.tmpIdioma == 'pt-PT'){
        this.variablesGlobales.localeMbs = localePtPT
      }else if(this.tmpIdioma == 'uk-UA'){
        this.variablesGlobales.localeMbs = localeUa
      }
      await this.servicioEncriptar.guardarEnStorage('idiomaSeleccionado', JSON.stringify(this.variablesGlobales.idiomaSeleccionado));
      this.cerrarModal()
    }else{
      this.cerrarModal()
    }
  }

  cerrarModal(){
    this.modalCtrl.dismiss();
  }
}
